<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <BaseTable
        ref="baseTable"
        url="/admin/org/index?is_tree=1"
        :tableData.sync="tableData"
        :searchParams="searchData"
        :columns="columns"
        :paramsCepCallback="paramsCepCallback"
      >
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="setRegion(row)">
			  设置地区
		  </el-button>
        </template>
      </BaseTable>
	  <BaseDialog
	    :visible.sync="dialogVisible"
	    title="设置地区"
	    @confirm="handleDialogConfirm"
	  >
	    <BaseForm
	      ref="baseForm"
	      v-model="formData"
	      :formOptions="regionFormOption"
	      :rules="rules"
	      itemWidth="100%"
	    ></BaseForm>
	  </BaseDialog>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns,regionFormOption,rules } from "./columns";

export default {
  name: "orgset",
  comments: {},
  data() {
    return {
      tableData: [],
      orgOption: [],
	  classOptions: [],
      searchData: {
        date: [],
      },
	  formData: {
		orgName: '',
	    rateRegion: '',
	  },
	  dialogVisible: false,
    };
  },
  computed: {
    columns,
    searchFormOption,
	regionFormOption,
	rules
  },
  created() {
	  this.getOrg();
	  this.getRegion();
  },
  methods: {
	  getOrg() {
		  // 获取机构
		this.$api.post("/admin/org/index", {}).then((res) => {
		  this.orgOption = res?.data?.data;
		});
	  },
	getRegion(){
		const arr = [];
		// 获取地区
		this.$api.post("/admin/org/getRegion", {}).then((res) => {
			if(res.data){
				res.data.forEach((k,v)=>{
					arr.push(k);
				})
			}
		  this.classOptions = arr;
		});
	},
    setRegion(row) {
		// 设置地区
		this.formData = { ...row };
		this.dialogVisible = true
	},
	// 抽屉内容提交
	handleDialogConfirm(cb) {
		// 用来结束loading
		this.$refs.baseForm.onSubmit(async (validate) => {
		  if (validate) {
		    const confirm = await this.$confirm('是否确认提交？', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning',
		    }).catch(() => {});
		    if (confirm) {
		      await this.$api.post('/admin/org/orgSetRegion', { 'id':this.formData.id,'region':this.formData.rateRegion }, '设置地区');
		      this.dialogVisible = false;
		      this.handleSearch();
		    }
		    cb(false);
		  } else {
		    cb();
		  }
		});
	},
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      const beginTime = params.date ? params.date[0] : '';
      const endTime = params.date ? params.date[1] : '';

      return {
        ...params,
        beginTime,
        endTime,
      };
    },
  },
};
</script>
